import { SET_DNI_ACTION } from "./reducersConstants";

export const setDniAction = (data) => {
  return {
    type: SET_DNI_ACTION,
    data,
  };
};

export const dniReducer = (previousState = "", { type, data }) => {
  switch (type) {
    case SET_DNI_ACTION:
      return data;
    default:
      return previousState;
  }
};
